<template>
    <app-layout title="Create Survey">
        <template v-slot:header>
            <h2 class="font-bold text-4xl dark:text-gray-200"> Create Survey </h2>
        </template>

        <div>
            <survey-editor :survey-model="surveyModel"
                           :default-logo="defaultLogo"
                           :default-profile-fields="defaultProfileFields"
                           :default-intro-text="defaultIntroText"
                           :default-email-text="defaultEmailText"
                           :query-step="step"
                           :unit-Prices="unitPrices"
            />
        </div>
    </app-layout>
</template>

<script>
import AppLayout from '@/Layouts/AppLayout';
import SurveyEditor from "@/Components/SurveyEditor";

export default {
    components: {
        SurveyEditor,
        AppLayout,
    },
    props: {
        step: Number|String,
        surveyModel: Object,
        defaultLogo: Object,
        defaultIntroText: String,
        defaultEmailText: String,
        defaultProfileFields: Array,
        unitPrices: Array,
    },
}
</script>
